import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import MediaServer from 'components/Common/MediaServer/MediaServer';
import ManageSubscription from 'components/Account/ManageSubscription/ManageSubscription';
import useGtmPageView from 'hooks/gtm/useGtmPageView';
import { ENV_MEDIAS_BASE_URL_ACCOUNT } from 'settings/env';
import { GTM_PAGE_OTHER } from 'settings/gtm/gtmPageView';

export default function Subscriptions(): JSX.Element {
  const { t } = useTranslation(['newslettersSubPage']);
  const mySubscriptionsUrlCms = ENV_MEDIAS_BASE_URL_ACCOUNT
    ? ENV_MEDIAS_BASE_URL_ACCOUNT + '/mes-abonnements.html'
    : undefined;

  useGtmPageView(GTM_PAGE_OTHER, '');

  return (
    <div>
      <Helmet>
        <title>
          {t('META_TITLE_TEMPLATE', {
            title: t('NEWSLETTER_META_TITLE'),
            ns: 'translation',
          })}
        </title>
      </Helmet>
      <ManageSubscription />
      {mySubscriptionsUrlCms && (
        <MediaServer path={mySubscriptionsUrlCms}>
          {({ render }) => <div>{render()}</div>}
        </MediaServer>
      )}
    </div>
  );
}
